/**
 * Verifica se para cada linha exista uma resposta (coluna) correspondente,
 * e caso não exista, preenche os dados com valores zero. Isto serve
 * para garantir a conformidade das dimensões da grade linha x colunas
 * na visualização do gráfico e do gráfico no relatório.
 * 
 * Exemplo:
 * 
 * linhas = ["A", "B"]
 * respostas = { linha = "A", resposta = "a", valor_numerico = 1 }, { LINHA = "A", resposta = "b", valor_numerico = 1 }
 * 
 * output esperado: 
 * { ...respostasAnteriores } + 
 * { linha = "B", resposta = "a", valor_numerico = 0 }, { LINHA = "B", resposta = "2", valor_numerico = 0 }
 *
 * @param {*} data 
 * @returns 
 */
function adaptarRespostasPorLinhas(data) {
  const linhas = [...new Set(data.map((value) => value.name).reverse())];
  const dataProcessada = [...data];
  const respostasPorLinha = {};

  for (let j = 0; j < linhas.length; j ++) {
    const linha = linhas[j];

    for (let i = 0; i < dataProcessada.length; i ++) {
      const resposta = dataProcessada[i];
      
      if (!respostasPorLinha[linha]) {
        respostasPorLinha[linha] = {};
      }
  
      if (!respostasPorLinha[linha][resposta.label]) {
        respostasPorLinha[linha][resposta.label] = 0;
      }

      if (linha === resposta.name) {
        respostasPorLinha[linha][resposta.label] = respostasPorLinha[linha][resposta.label] + 1;
      }
    }
  }

  const respostasPorLinhaKeys = Object.keys(respostasPorLinha);

  for (let k = 0; k < respostasPorLinhaKeys.length; k ++) {
    const linha = respostasPorLinhaKeys[k];
    const respostas = respostasPorLinha[linha];

    const respostasKeys = Object.keys(respostas);

    for (let j = 0; j < respostasKeys.length; j ++) {
      const resposta = respostasKeys[j];
      const quantidadeDeRespostaPorLinha = respostas[resposta];

      if (quantidadeDeRespostaPorLinha === 0) {
        dataProcessada.push({
          value: 0,
          numeric: 0,
          name: linha,
          label: resposta,
        });
      }
    }

  }

  return dataProcessada;
}

export function toEchartData(respostas) {
  if (!respostas || respostas.length === 0) {
    return { legends: [], data: [] };
  }

  const data = respostas.map((resposta, index) => ({
    value: resposta.resultado_percentual,
    numeric: resposta.resultado_numerico,
    name: resposta.enunciado,
    label: resposta.linha,
  }));

  const dataProcessada = adaptarRespostasPorLinhas(data)
    .sort((d1, d2) => d1.numeric - d2.numeric);

  const legends = [...new Set(dataProcessada.map((value) => value.name).reverse())];

  return {
    legends,
    data: dataProcessada,
  };
}
